"use client";
import { ArrowUp } from "lucide-react";
import { Customer } from "@/api/types";
import { Badge } from "@/components/ui/badge";
import { formatPhoneNumber, getCustomerAvatarSrc, getCustomerName } from "@/lib/utils";
import { Avatar } from "@/ui/elements/avatar";
import { NEW_CONTACTS } from "../homepage/constants";
import { NewContactsChart } from "./new-contacts-chart";

export function NewLeads(props: { length?: number }) {
  const contacts = NEW_CONTACTS.slice(0, props.length);
  return (
    <>
      <div className="border-b py-2 px-2.5">
        <div className="flex items-center justify-between w-full">
          <p className="md:text-base text-xs font-medium">New leads</p>
          <Badge variant="default" className="ml-2 text-xs">
            <ArrowUp className="shrink-0 w-3 h-3" />
            480
          </Badge>
        </div>
      </div>
      <NewContactsChart />
      <ul className="p-2 space-y-2">
        {contacts.map((contact) => (
          <li key={contact.id}>
            <div className="gap-x-3 flex items-center">
              <Avatar
                name={getCustomerName(contact as Customer)}
                src={getCustomerAvatarSrc(contact as Customer)}
                size="xs"
                subtle
              />
              <div>
                <p className="text-xs font-medium">{getCustomerName(contact as Customer)}</p>
                <p className="text-xs text-[11px] text-muted-foreground">
                  {formatPhoneNumber((contact as Customer).phoneNumber)}
                </p>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
}
